import Service 			from "./../../Libs/Service";
import _ 				from "lodash";

import { Cluster } 		from "./Cluster";

let Metadata = new Service({

	Name: "Metadata",

	Events: {

	},

	Actions: {

		// Получение метаданных из БД
		"Metadata": function(metadata) {

			// Сюда могут приходить неполные метаданные поэтому нельзя обращаться к metadata.что-то - лучше использовать Metadata.что-то или this.что-то

			_.extend(this, metadata);

			// Номер ноды, к которой подключён клиент, становится известен из метаданных: первичное
			// соединение переезжает из временного ключа 0 в ключ с настоящим номером ноды
			// (Client/Libs/Service.Socket.js, setPrimaryServerId)
			if (metadata.ServerId) {

				Server.setPrimaryServerId(metadata.ServerId);

				// Пока не выбран паблишер другой ноды, рабочая нода - нода аккаунта: с неё приходят
				// пользователь и списки паблишеров, поэтому активными должны быть её карты данных
				if (!Publisher.SelectedPublisher) Cluster.useServer(metadata.ServerId);

			}

			this.AIVendorsByCodename = _.keyBy(Metadata.AIVendors, "codename");
			this.AIModelsByHierarchy = _.mapValues(_.groupBy(Metadata.AIModels, "vendor_codename"), v => _.keyBy(v, "codename"));
			this.AIStylesByHierarchy = _.mapValues(_.groupBy(Metadata.AIStyles, "vendor_codename"), objs => _.mapValues(_.groupBy(objs, "model_codename"), objs => _.keyBy(objs, 'codename')));
			this.AISizesByHierarchy = _.mapValues(_.groupBy(Metadata.AISizes, "vendor_codename"), objs => _.mapValues(_.groupBy(objs, "model_codename"), objs => _.keyBy(objs, 'codename')));

			this.CreativePlayableSettingsByCodename = _.keyBy(Metadata.CreativePlayableSettings, "codename");
			this.CreativePlayableSettingsPublisherByCodename = _.mapValues(_.groupBy(Metadata.CreativePlayableSettingsPublisher, "publisher_id"), v => _.keyBy(v, "codename"));

			this.WorkspacesByCodename = _.keyBy(Metadata.Workspaces, "codename");
			this.ReleasesByCodename = _.keyBy(Metadata.Releases, "codename");
			this.ElementsByCodename = _.keyBy(Metadata.Elements, "codename");
			this.ElementPropertiesByCodename = _.keyBy(Metadata.ElementProperties, "codename");

			// Производные свойства элементов для раздельного задания значений по ориентациям
			// (position -> positionPortrait / positionLandscape). Нужны редактору, чтобы работать с этими
			// codename так же как с обычными свойствами (значение по умолчанию, revert, описания и т.д.)
			_.each(Metadata.ElementProperties, elementProperty => {

				_.each(['Portrait', 'Landscape'], suffix => {

					this.ElementPropertiesByCodename[elementProperty.codename + suffix] = _.extend({}, elementProperty, {
						codename: elementProperty.codename + suffix,
						baseCodename: elementProperty.codename
					});

				});

			});
			this.AnimationPropertiesByCodename = _.keyBy(Metadata.AnimationProperties, "codename");
			this.EmitterPropertiesByCodename = _.keyBy(Metadata.EmitterProperties, "codename");
			this.EventsByCodename = _.keyBy(Metadata.Events, "codename");
			this.EventActionsByCodename = _.keyBy(Metadata.EventActions, "codename");
			this.StylesByCodename = _.keyBy(Metadata.Styles, "codename");
			this.AccessByCodename = _.keyBy(Metadata.Access, "codename");
			this.GenresByCodename = _.keyBy(Metadata.Genres, 'codename');
			this.GenresByHierarchy = _.mapValues(_.groupBy(Metadata.Genres, "category_codename"), objs => _.keyBy(objs, 'codename'));
			this.GenreCategoriesByCodename = _.keyBy(Metadata.GenreCategories, "codename");

			this.FontsByCodename = _.keyBy(Metadata.Fonts, "codename");

			this.ElementStylesByCodename = _.keyBy(Metadata.ElementStyles, "codename");

			this.TemplateEndCardsByCodename = _.keyBy(this.TemplateEndCards, "codename");
			this.TemplateEndCardAssetsByEndCardByCodename = _.mapValues(_.groupBy(Metadata.TemplateEndCardAssets, "end_card_id"), objs => _.keyBy(objs, 'codename'));
			this.TemplateEndCardLocalizationByEndCardByCodename = _.mapValues(_.groupBy(Metadata.TemplateEndCardLocalization, "end_card_id"), objs => _.keyBy(objs, 'codename'));
			this.TemplateEndCardSettingsByEndCardByCodename = _.mapValues(_.groupBy(Metadata.TemplateEndCardSettings, "end_card_id"), objs => _.keyBy(objs, 'codename'));
			this.TemplateEndCardScreensByEndCardByCodename = _.mapValues(_.groupBy(Metadata.TemplateEndCardScreens, "end_card_id"), objs => _.keyBy(objs, 'codename'));
			this.TemplateEndCardElementsByEndCardByCodename = _.mapValues(_.groupBy(Metadata.TemplateEndCardElements, "end_card_id"), objs => _.mapValues(_.groupBy(objs, "screen_codename"), objs => _.keyBy(objs, 'codename')));
			this.TemplateEndCardAnimationsByEndCardByCodename = _.mapValues(_.groupBy(Metadata.TemplateEndCardAnimations, "end_card_id"), objs => _.mapValues(_.groupBy(objs, "screen_codename"), objs => _.keyBy(objs, 'codename')));
			this.TemplateEndCardAnimationStepsByEndCardByCodename = _.mapValues(_.groupBy(Metadata.TemplateEndCardAnimationSteps, "end_card_id"), objs => _.mapValues(_.groupBy(objs, "screen_codename"), objs => _.groupBy(objs, 'animation_codename')));

			this.TemplatesByCodename = _.keyBy(Metadata.Templates, "codename");
			this.TemplatesByType = _.groupBy(Metadata.Templates, "type");

			this.TemplateAssetsByTemplateByCodename = _.mapValues(_.groupBy(Metadata.TemplateAssets, "template_id"), objs => _.keyBy(objs, 'codename'));
			this.TemplateLocalizationByTemplateByCodename = _.mapValues(_.groupBy(Metadata.TemplateLocalization, "template_id"), objs => _.keyBy(objs, 'codename'));
			this.TemplateSettingsByTemplateByCodename = _.mapValues(_.groupBy(Metadata.TemplateSettings, "template_id"), objs => _.keyBy(objs, 'codename'));
			this.TemplateScreensByTemplateByCodename = _.mapValues(_.groupBy(Metadata.TemplateScreens, "template_id"), objs => _.keyBy(objs, 'codename'));
			this.TemplateElementsByTemplateByCodename = _.mapValues(_.groupBy(Metadata.TemplateElements, "template_id"), objs => _.mapValues(_.groupBy(objs, "screen_codename"), objs => _.keyBy(objs, 'codename')));
			this.TemplateAnimationsByTemplateByCodename = _.mapValues(_.groupBy(Metadata.TemplateAnimations, "template_id"), objs => _.mapValues(_.groupBy(objs, "screen_codename"), objs => _.keyBy(objs, 'codename')));
			this.TemplateAnimationStepsByTemplateByCodename = _.mapValues(_.groupBy(Metadata.TemplateAnimationSteps, "template_id"), objs => _.mapValues(_.groupBy(objs, "screen_codename"), objs => _.mapValues(_.groupBy(objs, "element_codename"), objs => _.keyBy(objs, 'id'))));
			this.TemplateEmittersByTemplateByCodename = _.mapValues(_.groupBy(Metadata.TemplateEmitters, "template_id"), objs => _.mapValues(_.groupBy(objs, "screen_codename"), objs => _.mapValues(_.groupBy(objs, "element_codename"), objs => _.keyBy(objs, 'codename'))));
			this.TemplateEventsByTemplateId = _.mapValues(_.groupBy(Metadata.TemplateEvents, "template_id"), objs => _.keyBy(objs, 'id'));
			this.TemplateEventsByHierarchy = _.mapValues(_.groupBy(Metadata.TemplateEvents, "template_id"), objs => _.mapValues(_.groupBy(objs, "screen_codename"), objs => _.mapValues(_.groupBy(objs, "element_codename"), objs => _.keyBy(objs, 'codename'))));

			Metadata.TemplatePlayablesByCodename = _.keyBy(Metadata.TemplatePlayables, 'codename');

			document.title = Metadata.Config['dashboard-page-title'];

			this.loaded = true;

			Broadcast.call("Metadata Loaded");

		}

	},

	init() {

		this.loaded = false;

		this.Config = {};

	},

	isReleaseAvailable(publisher, release) {

		if (!release['enabled']) return false;

		if (!release.options['scope'].includes(this.scope)) return false;

		if (release.codename in (publisher.options['Releases'] || {})) return publisher.options['Releases'][release.codename];

		return release.options["enabledByDefault"];

	},

	/**
	 * This code is licensed under the terms of the MIT license
	 *
	 * Deep diff between two object, using lodash
	 * @param  {Object} object Object compared
	 * @param  {Object} base   Object to compare with
	 * @return {Object}        Return a new object who represent the diff
	 */
	difference(object, base) {
		function changes(object, base) {
			return _.transform(object, (result, value, key) => {
				if (!_.isEqual(value, base[key])) {
					result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
				}
			});
		}
		return changes(object, base);
	}

});

window.Metadata = Metadata;

export { Metadata };

